import React, { useState, useEffect } from "react";
import { RadioGroup, Popover } from "@headlessui/react";
import Button from "../actions/Button";
import { ChevronDownIcon, ChevronUpIcon } from "@heroicons/react/outline";
import * as Text from "@/components/text";
import { useRouter } from "next/router";
import { localeTexts } from "@/utils/locale";

export const initiativesMap = (locale) => [
  {
    nameKey: "initiatives.gira.title",
    slug: "gira-ambulante",
  },
  {
    nameKey: "initiatives.presenta.title",
    slug: "ambulante-presenta",
  },
  {
    nameKey: "initiatives.masAlla.title",
    slug: "ambulante-mas-alla",
  },
];

const getInitiativeName = (initiative, locale) => {
  const [section, subSection] = initiative.nameKey.split('.');
  return localeTexts[locale]?.[section]?.[subSection]?.title || initiative.nameKey;
};

export default function RadioFilterList() {
  const router = useRouter();
  const query = router.query;
  const locale = router.query.locale || "es-MX";
  const t = localeTexts[locale]?.common || {};

  const initialValue = query.iniciativa
    ? initiativesMap(locale).find((i) => i.slug === query.iniciativa)
    : {};

  const [selectedInitiative, setSelectedInitiative] = useState(initialValue);

  useEffect(() => {
    if (selectedInitiative.slug && query?.iniciativa !== selectedInitiative.slug) {
      router.push({
        pathname: "/catalogo",
        query: { 
          iniciativa: selectedInitiative.slug,
          locale: locale 
        },
      });
    }
  }, [selectedInitiative, locale]);

  return (
    <Popover className="relative">
      {({ open }) => (
        <>
          <Popover.Button
            as={Button}
            color={open ? "white-on-black-no-hover" : "white-on-black"}
            label={selectedInitiative.nameKey  
              ? getInitiativeName(selectedInitiative, locale)
              : t.allPrograms || "Todos los programas"}
            trailingIcon={
              open ? (
                <ChevronUpIcon width={32} height={32} />
              ) : (
                <ChevronDownIcon width={32} height={32} />
              )
            }
            className={"w-[240px] px-4 text-[14px] font-bold"}
          />

          <Popover.Panel className="absolute z-10 w-full border border-black bg-white shadow-xl">
            <RadioGroup
              value={selectedInitiative}
              className="w-full divide-y-2"
              onChange={setSelectedInitiative}
            >
              <div className="flex w-full items-center">
                <RadioGroup.Option
                  value={{}}
                  className="flex w-full px-3 py-3 focus:ring-black"
                >
                  {({ checked }) => (
                    <div
                      className="flex w-full items-center"
                      onClick={() => {
                        setSelectedInitiative({});
                        router.push({
                          pathname: "/catalogo",
                          query: { locale: locale }
                        });
                      }}
                    >
                      <RadioGroup.Label
                        htmlFor={"todas-las-peliculas"}
                        className="block w-full text-sm font-medium leading-6 text-gray-900"
                      >
                        <Text.Label>
                          {t.allPrograms || "Todos los programas"}
                        </Text.Label>
                      </RadioGroup.Label>
                      <div className="flex-grow"></div>
                      <input
                        id={"todas-las-peliculas"}
                        name="notification-method"
                        type="radio"
                        checked={!selectedInitiative.slug}
                        className="h-4 w-4 border-gray-300 text-black focus:ring-black"
                      />
                    </div>
                  )}
                </RadioGroup.Option>
              </div>

              <div className="bg-neutral-50 px-3">
                <Text.ButtonLabel
                  className="uppercase text-neutral-500"
                  size="02"
                >
                  {t.programsSection || "Por programas"}
                </Text.ButtonLabel>
              </div>
              {initiativesMap(locale).map((initiative) => (
                <div key={initiative.slug} className="flex w-full items-center">
                  <RadioGroup.Option
                    value={initiative}
                    className="flex w-full px-3 py-3 focus:ring-black"
                  >
                    {({ checked }) => (
                      <div className="flex w-full items-center">
                        <RadioGroup.Label
                          htmlFor={initiative.slug}
                          className="block w-full text-sm font-medium leading-6 text-gray-900"
                        >
                          <Text.Label>
                            {getInitiativeName(initiative, locale)}
                          </Text.Label>
                        </RadioGroup.Label>
                        <div className="flex-grow"></div>
                        <input
                          id={initiative.slug}
                          name="notification-method"
                          type="radio"
                          checked={checked}
                          className="h-4 w-4 border-gray-300 text-black focus:ring-black"
                        />
                      </div>
                    )}
                  </RadioGroup.Option>
                </div>
              ))}
            </RadioGroup>
          </Popover.Panel>
        </>
      )}
    </Popover>
  );
}